import React, { useRef, useEffect, useState } from "react"
import $ from "jquery"
import "./Detalhes.css"
import HTML from 'html-react-parser';
import CarouselB2Z from "../../Componentes/CarouselB2Z/CarouselB2Z.js";
import { LocalData } from "../../Componentes/Util/LocalData"
import { ChevronLeft, Heart, HeartFill } from 'react-bootstrap-icons';
import CaminhoRato from "../../Componentes/Cabecalho/CaminhoRato.js";
import ReactPlayer from 'react-player'
import RodapePaginaSuspensa from "../../Componentes/Rodape/RodapePaginaSuspensa.js";

const DetalhesEventos = ({Lista}) => {
    const [isPlayerVisible, setPlayerVisibility] = useState(false);
    const [playing, setPlaying] = useState(false);
    const playerRef = useRef(null); // Create a ref using useRef
    const play = () => setPlaying(true);
    const pause = () => setPlaying(false);

    const evFecharDetalhe = () => {
        $(".area-produto").removeClass("produto-selecionado");
        $("body").removeClass("overflow-hidden");
        //$("ReactPlayer").prop("url", "");
        pause();
    }

    window.addEventListener("resize", function() {
        if($(window).width() < 1280){
            $("#videoEvento").css("height", (680*$(window).width())/1280 + "px");
        } else {
            $("#videoEvento").css("height", "680px");
        }
    });

    return (
            <div className="area-produto">
            <div className="btn-fechar-detalhe-produto" onClick={evFecharDetalhe}>X</div>
            {            
                Lista.map((a, index) => {
                    let dados = JSON.parse(a.dados);
                    let _listaAnexos = dados.anexos || [];
                    
                    //verifica se existe o link do video, caso exista, adiciona na lista de anexos
                    //se não existir, apenas retorna a lista de anexos
                    // try{
                    //     _listaAnexos = (dados.seo.linkVideo || "") 
                    //     ? [{
                    //         nome: "Video",
                    //         tipo: "mp4",
                    //         url: dados.seo.linkVideo,
                    //     }, ...dados.anexos] : dados.anexos;
                    // }catch(error){
                    //     _listaAnexos = dados.anexos;
                    // }

                    //console.log("dados", dados.anexos, _listaAnexos);
                return(
                    <div key={index} className="conteudo">
                        {
                            // console.log("dados", dados)
                        }
                        {
                            (dados.seo.linkVideo && dados.seo.linkVideo !== "" && dados.seo.linkVideo !== "null" && dados.seo.linkVideo !== "undefined") 
                                ? <ReactPlayer ref={playerRef} playing={playing} onPlay={play} onPause={pause} id="videoEvento" width="100%" height="680px" style={{maxHeight:"680px"}} url={dados.seo.linkVideo} controls />
                                : null
                        }
                        <div className="detalhe-produto">
                            <div>
                                <CarouselB2Z lista={_listaAnexos} width={"400px"} height={"400px"} />
                            </div>
                            <div className="descricao-produto">
                                {/* <div className="area-caminho-rato">
                                    <div className="btn-voltar-caminho-rato" onClick={evFecharDetalhe}><ChevronLeft size={12} /> Voltar</div>
                                    <h3><CaminhoRato caminho={JSON.parse(a.dados).arvoreCategoria[JSON.parse(a.dados).arvoreCategoria.length-1].descricaoCompleta} divisor={">"} /></h3>
                                </div> */}
                                <h3>
                                    {
                                        dados.nome.split("!!EV!!")[1]
                                    }
                                </h3>
                                <span>{HTML(dados.descricaoComplementar)}</span>
                            </div>
                        </div>
                    </div>
                    )
                })
            }
            <RodapePaginaSuspensa></RodapePaginaSuspensa>
            </div>
    )
}

export default DetalhesEventos;